import React from "react";

function OclockOrderPaymentIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        d="M12 9V13H16"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="white"
        stroke-linecap="round"
        stroke-dasharray="0.5 3.5"
      />
    </svg>
  );
}

export default OclockOrderPaymentIcon;
